import {useTranslation} from 'react-i18next';
import {ButtonProps} from '@guestapp/old-ui-kit';
import ModalSheet, {type ModalSheetProps} from 'components/common/ModalSheet';
import StandardModalSheet, {
  type StandardModalSheetProps,
} from 'components/common/StandardModalSheet';

type InternalStandardModalSheetProps = Pick<StandardModalSheetProps, 'text' | 'buttons'>;
type InternalModalSheetProps = Pick<
  ModalSheetProps,
  'isOpenModalSheet' | 'withModalMobileCloseButton' | 'title' | 'closeOnDocumentClick'
>;

type NotificationModalProps = {
  buttonLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};
type Props = InternalStandardModalSheetProps &
  InternalModalSheetProps &
  NotificationModalProps;
function NotificationModal({
  buttonLabel,
  buttons,
  text,
  onConfirm,
  onClose,
  ...props
}: Props) {
  const {t} = useTranslation();

  const internalButtons: ButtonProps[] = [
    {
      label: buttonLabel || t('understood'),
      primary: true,
      onClick: onConfirm,
    },
  ];
  return (
    <ModalSheet {...props} handleCloseModal={onClose}>
      <StandardModalSheet buttons={buttons || internalButtons} text={text} />
    </ModalSheet>
  );
}

export {NotificationModal};
